import React, { useState } from 'react';
import './user-login.scss';
import { useStores } from '../store';
import { observer } from 'mobx-react-lite';
import { Popover, Tooltip } from 'antd';
import CustomIcon, { IconType } from '../shared/custom-icon/custom-icon';
import { ActivityActionsRequest } from 'src/utils/enums';
import { isDemoEnv } from '@src/utils/envLinksUtil';
import demoService from '../../services/demo.service';
import SwitchIcon from '@svg/switch.svg?react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'src/utils/use-navigate';
import UserSettingsModal from '@src/components/features/user-settings/user-settings-modal';

export const UserLogin: React.FC = observer(() => {
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const { userStore, activityStore, customerStore } = useStores();
    const [isUserSettingsModalOpen, setIsUserSettingsModalOpen] = useState<boolean>(false);

    const navigate = useNavigate();

    const logout = async () => {
        await activityStore.sendActivityLog(ActivityActionsRequest.SIGN_OUT);
        userStore.sendIdentifyEvent();
        await userStore.logout();
    };

    const resetDemo = async () => {
        await demoService.resetDemoData();
        customerStore.reset();
        navigate('/');
    };

    const openUserSettingsModal = () => {
        setIsPopoverOpen(false);
        setIsUserSettingsModalOpen(true);
    };

    const closeUserSettingsModal = () => {
        setIsUserSettingsModalOpen(false);
    };

    const userInfoContent = (
        <div className={'user-info-content'}>
            <div className={'user-details'}>
                <div className="user-acronyms">{userStore.getUserNameAcronyms}</div>
                <Tooltip title={customerStore.selectedCustomer?.customerName} overlayClassName="tooltip-wrapper" placement="bottom">
                    <div className="customer-name">{customerStore.selectedCustomer?.customerName}</div>
                </Tooltip>
                <div className="email">{userStore.email}</div>
            </div>
            {isDemoEnv() && <button type="button" className={'reset-demo'} onClick={resetDemo}>
                <CustomIcon type={IconType.TRASH} />
                Reset Demo
            </button>}
            {userStore.userCustomers?.length > 1 && <div className="switch-customer-link">
                <Link to="/select-customer"><SwitchIcon />Switch Customer</Link>
            </div>}
            <button type="button" className="user-menu-item" onClick={openUserSettingsModal}>
                <CustomIcon type={IconType.CONFIGURATION} />
                Settings
            </button>
            <div className="popover-separator" />
            <button type="button" className={'sign-out'} onClick={logout}>
                <CustomIcon type={IconType.SIGN_OUT} />
                <div>Sign Out</div>
            </button>
        </div>
    );

    return (
        <>
            {userStore.isAuthenticated && (
                <>
                    <Popover
                        content={userInfoContent}
                        showArrow={false}
                        align={{ offset: [-130, 5] }}
                        open={isPopoverOpen}
                        onOpenChange={(open) => {
                            setIsPopoverOpen(open);
                        }}
                        placement={'bottom'}
                        overlayClassName={'user-container-content popover-overlay-menu'}
                    >
                        <div className={'user-container'}>
                            <div className="user-name">{userStore.getUserNameAcronyms}</div>
                        </div>
                    </Popover>
                    {isUserSettingsModalOpen &&
                        <UserSettingsModal onCloseHandler={closeUserSettingsModal} />
                    }
                </>
            )}
        </>
    );
});


